import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import About1 from '../layout/about/about1';

const Header = () => {
    const headerInitialized = useRef(false);

    const manageHeader = () => {
        var mainHeader = $(".main-header");

        if (!headerInitialized.current) {
            mainHeader.after('<div class="sticky-header"></div><div class="non-sticky-header"></div>');
            $(".sticky-header").html(mainHeader.html());
            headerInitialized.current = true;
        }

        var triggerPoint = mainHeader.height(),
            yOffset = 0;
        $(window).off("scroll").on("scroll", function () {
            yOffset = $(window).scrollTop();
            if (yOffset >= triggerPoint) {
                $(".sticky-header").addClass("sticky-fixed-top");
                $(".non-sticky-header").removeClass("non-sticky-fixed-top");
            }
        });
    }

    useEffect(() => {
        if (!headerInitialized.current) {
            manageHeader();
        }
    }, []);

    // Add this function to handle the mobile menu toggle


    return (
        <div>

            <header className="main-header">
                <div className="container">
                    <div className="main-header-wapper">
                        <div className="site-logo">
                            <Link to="/"><img src="assets/img/logo.png" alt="Logo" /></Link>
                        </div>
                        <div className="main-header-info">
                            <div className="top-header">
                                <ul className="top-left">
                                    <li><i className="fa fa-mobile-alt" /><a>+91 86672 - 96757 </a></li>
                                    <li><i className="fa fa-mobile-alt" /><a> +1 647-988-7328</a></li>
                                    <li><i className="fa fa-envelope" />contact@titatechnologies.com</li>
                                </ul>
                                <div className="top-right">

                                    <ul className="header-social-share">
                                        <li><a href="https://www.facebook.com/share/15nNHb6u7n/?mibextid=wwXIfr" target="_blank"><i className="fa-brands fa-facebook-f" /></a></li>
                                        <li><a href="https://wa.me/8667296757?text=Hello%20Tita%20Technologies%2C%20I%20would%20like%20to%20inquire%20about%20your%20services.%20Best%20regards%2C%20[Your%20Name]" target="_blank"><i className="fa-brands fa-whatsapp" /></a></li>
                                        <li><a href="https://www.linkedin.com/company/tita-technologies/" target="_blank"><i className="fa-brands fa-linkedin" /></a></li>
                                        <li><a href="https://www.instagram.com/tita_technologies_global/profilecard/?igsh=MThwcTc4dGw1ZXp3MA== " target="_blank"><i className="fa-brands fa-instagram" /></a></li>
                                        <li><a href="https://x.com/tita_global?s=11" target="_blank"><i class="fa-brands fa-x-twitter"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                            {/*/.top-header*/}
                            <div className="header-menu-wrap">
                                <ul className="nav-menu">
                                    <li>
                                        <Link to="/">Home</Link>

                                    </li>
                                    <li>
                                        <Link to="/about">About Us</Link>
                                        <ul>
                                            <li><Link to="/our-team" >Our Team</Link></li>
                                        </ul>
                                    </li>
                                    <li>
                                        <Link to="/service">IT Solutions</Link>
                                        <ul>
                                            <li><Link to="/training">IT Training & Upskills</Link></li>
                                            <li><Link to="/project">IT Projects</Link></li>
                                            <li><Link to="/staffing">IT Staffing & Consulting</Link></li>
                                            <li><Link to="/it-career">IT Career Counseling</Link></li>
                                            <li><Link to="/infrastructure">IT Infrastructure </Link></li>

                                        </ul>
                                    </li>
                                    <li>
                                        <Link to="/careers">Careers</Link>

                                    </li>
                                    <li>
                                        <Link to="/">TITA Buzz</Link>
                                        <ul>
                                            <li><Link to="/news">News</Link></li>
                                            <li><Link to="/events">Events</Link></li>
                                            <li><Link to="/socialMedia">Social Media Community</Link></li>


                                        </ul>
                                    </li>
                                    <li><Link to="/contact">Contact</Link></li>
                                </ul>
                                <div className="menu-right-item">

                                    <div className="mobile-menu-icon">
                                        <i className="fa-solid fa-ellipsis-vertical" />
                                    </div>
                                </div>
                            </div>
                            {/*/.header-menu-wrap*/}
                        </div>
                    </div>
                </div>
            </header>


        </div>
    );
};

export default Header;